<template>
  <div>

   <hr />

    <el-alert
        title="Under Development"
        type="warning"
        show-icon>
    </el-alert>

     <backhaul :rowData="rowData" />

     <insurance :rowData="rowData" />

     <permits :rowData="rowData" />

     <progress :rowData="rowData" />

     <requests :rowData="rowData" />

     <tenancy :rowData="rowData" />

  </div>
</template>


<script>

import Backhaul from '@/components/sites/calendar/Backhaul'
import Insurance from '@/components/sites/calendar/Insurance'
import Permits from '@/components/sites/calendar/Permits'
import Progress from '@/components/sites/calendar/Progress'
import Requests from '@/components/sites/calendar/Requests'
import Tenancy from '@/components/sites/calendar/Tenancy'


export default {

  components: {
    Backhaul,
    Insurance,
    Permits,
    Progress,
    Requests,
    Tenancy,
  },

  props: {
    rowData: {
      type: Object,
      required: true
    }
  }
}

</script>



// WEBPACK FOOTER //
// SiteCalendar.vue?fb45e49e